export function toPaneKey(element) {
  if (!element || !element.type || element.id === undefined || element.id === null) {
    return null;
  }

  return `${element.type}:${String(element.id)}`;
}

export function parseUpdatedAtMs(val) {
  if (!val) return null;
  if (val instanceof Date) return val.getTime();
  if (typeof val === 'number') return val;
  if (typeof val === 'string') {
    const match = val.match(/^(\d{2})\.(\d{2})\.(\d{4}),\s(\d{2}):(\d{2}):(\d{2})\s([+-]\d{4}|Z|UTC|GMT)$/);
    if (match) {
      const [, d, m, y, h, min, s, zone] = match;
      const utcMs = Date.UTC(
        Number.parseInt(y, 10),
        Number.parseInt(m, 10) - 1,
        Number.parseInt(d, 10),
        Number.parseInt(h, 10),
        Number.parseInt(min, 10),
        Number.parseInt(s, 10),
      );

      if (zone === 'Z' || zone === 'UTC' || zone === 'GMT') {
        return utcMs;
      }

      const sign = zone.startsWith('-') ? -1 : 1;
      const zoneHours = Number.parseInt(zone.slice(1, 3), 10);
      const zoneMinutes = Number.parseInt(zone.slice(3, 5), 10);
      const offsetMs = sign * ((zoneHours * 60) + zoneMinutes) * 60 * 1000;
      return utcMs - offsetMs;
    }

    const parsed = Date.parse(val);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return null;
}

export function toPositiveInt(value) {
  const numeric = Number.parseInt(String(value), 10);
  if (!Number.isFinite(numeric) || numeric <= 0) {
    return null;
  }
  return numeric;
}
